import AdminProduct from 'components/Admin/Product/AdminProduct';

const AdminProductPage = () => {
	return <AdminProduct />;
};

export default AdminProductPage;
